import client from "./client";

const employeeAttendanceApi = {
  selfCheckIn(body) {
    return client.post("/employee-attendance/checkin", body).then((r) => r.data);
  },

  markByAdmin(body) {
    return client.post("/employee-attendance/mark", body).then((r) => r.data);
  },

  getByDate(params = {}) {
    return client.get("/employee-attendance/daily", { params }).then((r) => r.data);
  },

  getHistory(employeeId, params = {}) {
    return client.get(`/employee-attendance/history/${employeeId}`, { params }).then((r) => r.data);
  },
};

export default employeeAttendanceApi;
